import { render, staticRenderFns } from "./InstituteAdd.vue?vue&type=template&id=4b41136f&"
import script from "./InstituteAdd.vue?vue&type=script&lang=js&"
export * from "./InstituteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports